import gql from 'graphql-tag';
import PaginatorInfoFragment from '../fragments/PaginatorInfoFragment';
import AdminProductListItem from '../fragments/AdminProductListItem';

export default gql`
query adminProductList($filters: AdminProductFilters, $sortBy: AdminProductOrder, $count: Int!, $page: Int) {
    adminProducts(filters: $filters, sortBy: $sortBy, first: $count, page: $page) {
        paginatorInfo {
            ...PaginatorInfoFragment
        }
        data {
            ...AdminProductListItem
        }
    }
}
${PaginatorInfoFragment}
${AdminProductListItem}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/adminProductList.ts